import React, { useEffect, useState } from "react";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import useForm, { Form } from "../../../../../hooks/useForm";
import Controls from "../../../../../components/form/controls/Controls";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Typography,
  Divider,
} from "@mui/material";
import { getReleaseAppOS } from "../../../../../apis/VersionRelease/operatingSystem.api";
import { getReleaseGroup } from "../../../../../apis/VersionRelease/group.api";
import { validationReleaseAppVersionInput } from "../../../utils/validateInput";

const initialValue = {
  id: "",
  name: "",
  versionName: "",
  versionCode: "",
  operatingSystemId: "",
  releaseGroupIds: [],
};

function ReleaseAppVersionForm(props) {
  const { addOrEdit, recordForEdit, errorsForm } = props;
  const [valueAddNew, setValueAddNew] = useState(initialValue);

  const [groups, setGroups] = useState([]);
  const [operatingSystems, setOperatingSystems] = useState([]);

  // validation input permission
  const validateFLFReleaseAppVersionForm = (fieldValues = values) => {
    let temp = validationReleaseAppVersionInput(fieldValues, { ...errors });

    setErrors({
      ...temp,
    });

    if (fieldValues === values)
      return Object.values(temp).every((x) => x === "");
  };

  const { values, setValues, errors, setErrors, handleInputChange, resetForm } =
    useForm(initialValue, true, validateFLFReleaseAppVersionForm);

  useEffect(() => {
    getReleaseAppOS({}, (result) => {
      setOperatingSystems([...result.list]);
    });

    // * Get list group
    getReleaseGroup({}, (result) => {
      setGroups([...result.list]);
    });
  }, []);

  useEffect(() => {
    setErrors({
      ...errorsForm,
    });
  }, [errorsForm, setErrors]);

  useEffect(() => {
    if (recordForEdit !== null) {
      const releaseGroupIds = recordForEdit.releaseGroups.map(
        (releaseGroup) => releaseGroup.id
      );
      recordForEdit.releaseGroupIds = releaseGroupIds;
      setValues({
        ...recordForEdit,
        releaseGroupIds,
      });
    } else {
      setValues({
        ...valueAddNew,
      });
      setErrors({});
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [recordForEdit]);

  const onSubmit = (e) => {
    e.preventDefault();
    if (validateFLFReleaseAppVersionForm()) {
      addOrEdit(values, resetForm);
      setValueAddNew(initialValue);
    }
  };

  const handleOnChange = (e) => {
    handleInputChange(e);

    if (!recordForEdit) {
      const { name, value, type } = e.target;
      setValueAddNew({
        ...valueAddNew,
        [name]: type === "number" ? +value : value,
      });
    }
  };

  return (
    <Form onSubmit={onSubmit}>
      <Controls.Input
        name="name"
        value={values.name}
        label="Name"
        type="text"
        onChange={handleOnChange}
        error={errors.name}
      />

      <Controls.Input
        name="versionName"
        value={values.versionName}
        label="Version Name"
        type="text"
        onChange={handleOnChange}
        error={errors.versionName}
      />

      <Controls.Input
        name="versionCode"
        value={values.versionCode}
        label="Version Code"
        type="text"
        onChange={handleOnChange}
        error={errors.versionCode}
      />

      {values.operatingSystemId !== null &&
      values.operatingSystemId !== undefined ? (
        <Controls.Select
          name="operatingSystemId"
          label="OS Name"
          value={values.operatingSystemId}
          onChange={handleOnChange}
          options={operatingSystems}
          disabled={recordForEdit !== null ? true : false}
          error={errors.operatingSystemId}
        />
      ) : null}

      <Accordion
        sx={{
          marginTop: "10px",
          color: "var(--txt-color)",
          backgroundColor: "var(--main-bg)",
        }}
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1a-content"
          id="panel1a-header"
        >
          <Typography>Group</Typography>
        </AccordionSummary>
        <AccordionDetails
          sx={{
            height: "200px",
            overflowY: "auto",
          }}
        >
          <Divider />
          <Controls.MultipleCheckbox
            name="releaseGroupIds"
            label="Groups"
            value={values.releaseGroupIds}
            onChange={handleOnChange}
            options={groups}
          />
        </AccordionDetails>
      </Accordion>

      <Controls.Button
        sx={{ width: "100%", marginTop: "10px" }}
        type="submit"
        text="Submit"
      />
    </Form>
  );
}

export default ReleaseAppVersionForm;
